import { Injectable } from '@angular/core';
import { filter, first, map, startWith } from 'rxjs/operators';
import { AppFeatureService, AppService, AppRoleService } from '@nk/access-block';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Observable } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  Breadcrumb,
  generateTabFromTabRoute,
  getActiveTabs,
  getBreadcrumbs,
  getFirstTabRoute,
  getMainNavigationPaths,
  NavigationItem,
  Tab,
} from '@nk/core/services/navigation.utils';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private _appFeatureService: AppFeatureService,
    private _appRoleService: AppRoleService,
    private _translationService: TranslateService,
    private _router: Router,
    private _appService: AppService,
  ) {}

  public getNavigation(): Observable<NavigationItem[]> {
    return combineLatest([
      this._router.events.pipe(
        filter((event, second) => {
          return event instanceof NavigationEnd;
        }),
        startWith(this._router), // So initial page load also triggers
      ),
      this._appFeatureService.activeAppFeatureDimsCache.get().pipe(first()),
      this._appRoleService.activeAppRoleDimsCache.get().pipe(first()), // Does this need to be uncached at some point?
    ]).pipe(
      map(([events, featureDims, roleDims]) =>
        getMainNavigationPaths(featureDims, roleDims, this._router.url, this._translationService),
      ),
    );
  }

  public getActiveNavigationTab(activatedRoute: ActivatedRoute): Observable<Tab[]> {
    return combineLatest([
      this._appFeatureService.activeAppFeatureDimsCache.get().pipe(first()),
      this._appService.identityDataCache.get().pipe(first()), // Does this need to be uncached at some point?
    ]).pipe(
      map(([appFeature, identity]) => {
        // we listen to navigation change so that the tabs are updated on new pageChange
        const tabs = this.getNavigationTab(activatedRoute);
        const adminFlag = identity.app_user.admin_flag;

        // TODO: add role check here also :)
        return getActiveTabs(tabs, appFeature, adminFlag, this._router.url);
      }),
    );
  }

  public getNavigationTab(route: ActivatedRoute): Tab[] {
    const tab = getFirstTabRoute(route);
    if (tab) {
      return generateTabFromTabRoute(tab.child, tab.url);
    } else {
      return [];
    }
  }

  public getBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    return getBreadcrumbs(route, url, breadcrumbs);
  }
}
